import React, { useEffect, useState } from "react";
import "./offcanvas.css";
import httpRequest from "../utils/Http";
import moment from "moment";

const TrackingSidebar = ({ show, handleClose, trackingDocket }) => {
  const [trackingData, setTrackingData] = useState({});
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !trackingDocket?.tracking_number) {
      setTrackingData({});
      return;
    }

    const getTracking = async () => {
      setLoading(true);
      try {
        const response = await httpRequest("gettrackingtetails", { tracking_number: trackingDocket.tracking_number }, "POST");
        setTrackingData(response.status && response.data ? response.data : {});
      } catch {
        setTrackingData({});
      } finally {
        setLoading(false);
      }
    };
    getTracking();
  }, [show, trackingDocket]);

  const getEventIcon = (detail = "") => {
    const status = detail.toLowerCase();
    if (status === "delivered") return "fa-check";
    if (status === "out for delivery") return "fa-flag";
    if (status.includes("pickup") || status === "pending") return "fa-box";
    return "fa-truck";
  };

  if (!trackingDocket?.courier_name) return null;
  const events = trackingData?.courier_tracking_events || [];

  return (
    <div className={`tracking-drawer ${show ? "tracking-drawer--open" : ""}`} aria-hidden={!show}>
      <button type="button" className="tracking-drawer__backdrop" aria-label="Close tracking" onClick={handleClose} />
      <aside className="tracking-drawer__panel" aria-label="Shipment tracking">
        <header className="tracking-drawer__header">
          <div><span>Shipment tracking</span><h5>{trackingDocket.courier_name.toUpperCase()}</h5><p>AWB: {trackingDocket.tracking_number}</p></div>
          <button type="button" className="tracking-drawer__close" aria-label="Close tracking" onClick={handleClose}>&times;</button>
        </header>
        <div className="tracking-drawer__body">
          {isLoading ? <div className="tracking-drawer__state"><i className="fas fa-spinner fa-spin" /><p>Fetching the latest tracking events…</p></div> : events.length ? (
            <ol className="tracking-drawer__timeline">
              {events.map((event, index) => <li key={`${event.checkpoint_date}-${index}`} className={`tracking-drawer__event ${index === 0 ? "tracking-drawer__event--latest" : ""}`}>
                <span className="tracking-drawer__icon"><i className={`fas ${getEventIcon(event.tracking_detail)}`} /></span>
                <article><strong>{event.tracking_detail || "Shipment updated"}</strong><time>{event.checkpoint_date ? moment(event.checkpoint_date).format("DD MMM YYYY · hh:mm A") : "Time unavailable"}</time>{event.location && <p>{event.location}</p>}</article>
              </li>)}
            </ol>
          ) : <div className="tracking-drawer__state"><i className="fas fa-map-marked-alt" /><p>No tracking details are available for this AWB yet.</p></div>}
        </div>
      </aside>
    </div>
  );
};

export default TrackingSidebar;
